export default {
	name: 'AY Skin Specialist Clinic',
	description: 'Dr. Adrian Yong Sze Wai, Consultant Dermatologist & Dermatological Surgeon. Specialised in Skin, Laser, Hair & Nails treatments.',
	phone: [
		{ label: 'Call (office hours)', number: '+60 12-320 3035' },
		{ label: 'Hotline', number: '+60 3-7710 0023' },
		{ label: 'Hotline 2', number: '+60 3-7733 0029' },
	],
	whatsapp: [
		{ label: 'WhatsApp (outside office hours)', number: '+60 12-320 3035' },
	],
	//phone: '+60 3-7710 0023',
	//mobilePhone: '+60 12 828 3035',
	email: 'enquiries@ayskinspecialist.com',
	address: `No 52, Jalan SS 21/1,
    Damansara Utama,
    47400 Petaling Jaya,
    Selangor, Malaysia.`,
	googleMapsLink: 'https://goo.gl/maps/2QG5mH5LEVx',
	googleMapsEmbed: 'https://goo.gl/3e8s8b',
	wazeLink: 'https://waze.to/?ll=3.1382,101.6185&n=T',
	waze: {
		appLink: 'waze://?ll=3.136044,101.620748&navigate=yes',
		fallbackLink: 'https://goo.gl/maps/2QG5mH5LEVx',
	},
	facebook: {
		pageLink: 'https://www.facebook.com/ayskinspecialist',
		pageLinkName: 'fb.com/AYSkinSpecialist',
	},
	openingHours: {
		'monday-saturday': {
			label: 'Monday - Saturday',
			value: '9:30am - 6:30pm',
			summary: true,
		},
		'tuesday': {
			label: 'Tuesday',
			value: '1:00pm - 6:30pm',
		},
	},
	recaptcha: {
		sitekey: '6LfsAiwUAAAAAGLnIsY463ajIQEJdvdDekgoOoT7',
		// sitekey: '6Lc9WUstAAAAABQTOCcJqEjjxMcFfPY27mLvz-uy',
	},
	turnstile: {
		sitekey: '0x4AAAAAADyhsMJ8k4BcDDpV',
	},
	api: {
		// endpoint: 'http://127.0.0.1:5001/api',
		// endpoint: window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : 'https://www.ayskinspecialist.com/api',
		endpoint: 'https://www.ayskinspecialist.com/api',
	},
	/*
	facebook: {
		pageLink: 'https://www.facebook.com/RichMonkeysTechnology/',
	},
	*/
	doctors: {
		'dr-adam-yusof': {
			name: 'Dr. Adam Yusof',
			title: 'Consultant Cosmetic Dermatologist, Skin Specialist and Laser Surgeon',
			introduction: [
				'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas viverra risus facilisis consectetur lobortis.',
				'Donec in ornare nibh. Vivamus molestie accumsan purus vitae posuere.',
				'In porta vulputate lacus, eget viverra dolor ultricies non.',
				'Fusce tellus ex, tristique malesuada ipsum ut, venenatis aliquam arcu.',
				'Curabitur tincidunt, augue et aliquet posuere, dolor purus mollis felis, in bibendum enim felis quis urna. Sed ac accumsan leo.',
				'Praesent varius quam et aliquam eleifend.',
				'Fusce elementum, diam vel auctor dictum, ex orci ullamcorper nunc, ut vehicula arcu lorem non augue.',
			].join(' '),
		},
	},
	products: {
		// 'ay_acne_clearing_essence': {
		// 	label: 'Acne Clearing Essence',
		// 	name: 'AY Acne Clearing Essence',
		// 	images: ['/images/products/acne_clearing_essence.jpg',],
		// 	content: [{
		// 		el: 'p',
		// 		content: '<b>For acne/rosacea-prone skin</b>',
		// 		escape: false,
		// 	}, {
		// 		el: 'p',
		// 		content: 'Natural plant extracts of Chamomile, Corallina officinalis and Ganoderma lucidum aid recovery of acne/rosacea. For best results, use in combination with AY Overnight Skin Renewal Cream.',
		// 	}, {
		// 		el: 'p',
		// 		content: '<i>Natural plant extract, Paraben free</i>',
		// 		escape: false,
		// 	}]
		// },
		'ay_overnight_skin_renewal_cream': {
			name: 'AY Overnight Skin Renewal Cream',
			images: ['/images/products/overnight_skin_renewal_cream.jpg',],
			content: [{
				el: 'p',
				content: '<b>For dull/pigmented/oily/congested skin</b>',
				escape: false,
			}, {
				el: 'p',
				content: 'Gentle exfoliating cream for use at night to renew dull, pigmented, oily and congested skin. For best results, apply AY Solar Defense in the daytime to minimise sun damage.',
			}, {
				el: 'p',
				content: '<i>Natural plant extract, Paraben free</i>',
				escape: false,
			}]
		},
		'ay_overnight_skin_renewal_essence': {
			name: 'AY Overnight Skin Renewal Essence',
			images: ['/images/products/overnight_skin_renewal_essence.jpg',],
			content: [
				{
					el: 'p',
					content: '<b>For dull and pigmentation-prone skin</b>',
					escape: false,
				},
				{
					el: 'p',
					content: 'Tranexamic acid and Liquorice root extract reduces pigmentation. Chamomile flower extract calms the skin and D-panthenol gives your skin a glow. For best results, use in combination with AY Overnight Skin Renewal Cream.',
				},
				{
					el: 'p',
					content: '<i>Natural plant extract, Paraben free</i>',
					escape: false,
				},
			]
		},
		'ay_gentle_cleansing_gel': {
			name: 'AY Gentle Cleansing Gel',
			images: ['/images/products/gentle_cleansing_gel.jpg',],
			content: [
				{
					el: 'p',
					content: '<b>Recommended for all skin conditions</b>',
					escape: false,
				},
				{
					el: 'p',
					content: 'A soap-free, cleansing gel that thoroughly removes impurities without disturbing the skin’s natural moisture. Sodium alginate hydrates and soothes skin, leaving it feeling soft and silky. Suitable as a make-up remover.',
					escape: false,
				},
				{
					el: 'p',
					content: '<i>Natural plant extract, Paraben free</i>',
					escape: false,
				},
			]
		},
		'ay_solar_defense': {
			name: 'AY Solar Defense',
			images: ['/images/products/solar_defense.jpg',],
			content: [
				{
					el: 'p',
					content: '<b>Recommended for all skin conditions</b>',
					escape: false,
				},
				{
					el: 'p',
					content: 'A lightweight, non-greasy 2-in-1 formulation sunscreen with encapsulation technology for maximal protection against photodamage. Unique plant extracts help reverse existing pigmentation, complementing the sunscreen in the prevention of new pigment formation.',
					escape: false,
				},
				{
					el: 'p',
					content: '<i>Natural plant extract, Paraben free</i>',
					escape: false,
				},
			]
		},

	},
	conditions: {
		'dermatology': {
			name: 'Dermatology',
			child: {
				'acne': {
					name: 'Acne',
					description: 'Acne affects up to 70% of our Malaysian secondary school children and medical students. The main factors contributing to acne include hormonal influence which causes oil-secreting glands to enlarge and produce more sebum.',
					images: [
						'/images/conditions/acne.jpg'
					], content: [
						{
							el: 'p',
							content: 'Acne affects up to 70% of our Malaysian secondary school children and medical students. The main factors contributing to acne include hormonal influence which causes oil-secreting glands to enlarge and produce more sebum. Drugs such as body-building steroids and mood-stabilising drugs can worsen acne. High carbohydrate diets, dairy products, chocolates and stress can all make acne worse.'
						}, {
							el: 'p',
							content: '<b>What we can do to help you?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Acne is normally diagnosed clinically. However, misdiagnosis can occur as there are several mimickers of acne and hence specialist opinion should be sought.',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Antibiotics - orally or applied - can reduce inflammation and infection related to acne<br><br>Isotretinoin tablets can be used to improve severe acne but must be used under the supervision of National Specialist Registered Dermatologist, as directed by the Ministry of Health Malaysia.<br><br>Lasers and skin peels may be used to treat active acne and also improve scars resulting from acne.<br><br>Prevention of recurrent acne flares can be achieved by using the AY Skin Acne-Care product range comprising a moisturising cleanser, clearing essence and acne sunscreen.',
							escape: false,
						},
					]
				},
				'skin-cancer': {
					name: 'Skin Cancer',
					description: 'Harmful ultraviolet (UV) rays from long-term sun exposure can lead to skin cancers overtime. Skin cancer can also affect people with family history of other cancers.',
					images: [
						'/images/conditions/skin_cancer.jpg'
					], content: [
						{
							el: 'p',
							content: 'Harmful ultraviolet (UV) rays from long-term sun exposure can lead to skin cancers overtime. Skin cancer can also affect people with family history of other cancers.'
						}, {
							el: 'p',
							// content: '<b>What we can do to help ?</b><br>Dr. Adrian Yong is highly experienced in skin cancer screening and management, having seen nearly 1500 skin cancers per year during his specialist training in the United Kingdom.',
							content: '<b>What we can do to help ?</b><br>We are highly experienced in skin cancer screening and management.',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Dermoscopic examination can determine the likelihood of skin cancer. In cases where skin cancer is suspected, a biopsy will be performed to confirm the diagnosis.',
							escape: false,
						}, {
							el: 'p',
							// content: '<i>Treatments</i><br>Surgical removal is performed to prevent the spread of cancer to other parts of the body. <br><br>Dr. Adrian Yong pioneered Mohs micrographic surgery in Malaysia ‒ internationally recognised as the gold standard in the management of non-melanoma skin cancers.',
							content: '<i>Treatments</i><br>Surgical removal is performed to prevent the spread of cancer to other parts of the body.',
							escape: false,
						},
					]
				},
				'allergy': {
					name: 'Allergy',
					description: 'One in three Malaysians (33%) are affected by some form of allergy. Atopic eczema, allergic rhinitis or conjunctivitis, and asthma make up the “allergy march”.',
					images: [
						'/images/conditions/skin-allergy.jpg'
					], content: [
						{
							el: 'p',
							content: 'One in three Malaysians (33%) are affected by some form of allergy. Atopic eczema, allergic rhinitis or conjunctivitis, and asthma make up the “allergy march”. Pollutants, climate change and urbanisation are all contributors to the development of the allergy march. Urticaria for less than 6 weeks can be due to infections, medications and allergen triggers. Urticaria longer than 6 weeks associated with joint pain and fever may suggest an underlying autoimmune condition. '
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Appropriate allergy testing can be performed and avoidance of known allergens can improve symptoms.<br><br>Autologous serum skin testing can be performed to detect autoimmunity (where a patient’s own serum is extracted and injected under their skin to test for any allergic reaction). ',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Tablets and creams are very effective in reducing any remaining symptoms.',
							escape: false,
						},
					]
				},
				'psoriasis': {
					name: 'Psoriasis',
					images: [
						'/images/conditions/psoriasis.jpg'
					], content: [
						{
							el: 'p',
							content: 'Up to 11% of the world’s population is affected by psoriasis. Psoriasis can cause unsightly, itchy and thickened scaly skin on elbows, knees, scalp, face and nails. Psoriasis can also affect joints and have been associated with the metabolic syndrome including high blood pressure, obesity and high cholesterol levels.'
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Blood tests can be done to detect underlying medical conditions',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Topical creams can be used to reduce the inflammation and flaking associated with psoriasis<br><br>Phototherapy can be targeted at selected areas that are stubborn and difficult to clear<br><br>Tablets to balance your immune system and reduce inflammation can be very effective<br><br>Biologic injections are now the gold standard in the treatment of psoriasis and produces excellent results for as long as the medication is continued',
							escape: false,
						},
					]
				},
				'eczema': {
					name: 'Eczema',
					images: [
						'/images/conditions/eczema_1.jpg', '/images/conditions/eczema_2.jpg',
					], content: [
						{
							el: 'div',
							content: 'Eczema simply refers to inflammation of the skin. Eczema can be due to the following causes:<br><ul><li>Genetic tendencies, more often seen in young children</li><li>Allergic skin reaction due to contact with items such as nickel, preservatives in creams, etc</li></ul>',
							escape: false,
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Allergy tests combined with proactive protection of the skin barrier is essential in the long term management of eczema',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Topical anti-inflammatory creams can be used to control eczema.<br><br>Carefully selected barrier repair creams will help reduce the number of eczema flares.<br><br>Phototherapy can be used to treat stubborn eczema areas.<br><br>Tablets to balance the immune system maybe used to control severe inflammation.<br><br>Biologic injections are soon available and may become the gold standard treatment for eczema in future.',
							escape: false,
						},
					]
				},
				'leg-ulcers-&-leg-swelling': {
					name: 'Leg Ulcers & Leg Swelling',
					images: [
						'/images/conditions/leg_ulcer.jpg'
					], content: [
						{
							el: 'p',
							content: 'Leg ulcers can be due to blood vessel malfunction or inflammation, pressure or nerve damage. Leg swelling and ulcers can be caused by underlying medical conditions such as kidney, heart or lung conditions. '
						}, {
							el: 'p',
							content: '<b>What we can do to help you?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Ultrasound examination of the heart and leg vessels is important to make a diagnosis. Blood tests can be performed to identify underlying medical causes.',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Tablets can help reduce swelling in the legs if serious underlying medical causes have been excluded.<br><br>Compression stockings may be recommended after an ultrasound has been performed to rule out blood supply restriction to your legs<br><br>Injection sclerotherapy can be performed to redirect blood flow into normal functioning blood vessels to improve leg ulcers',
							escape: false,
						},
					]
				},
				'children-services': {
					name: 'Children’s Services',
					images: [
						'/images/conditions/children-2.jpg'
					], content: [
						{
							el: 'p',
							content: 'Children’s skin is sensitive and should be protected from an early age to minimise photoageing and skin cancer with the best sunscreens. Eczema is a disabling condition during childhood. A systematic but often neglected approach is to improve skin barrier protection and avoidance of irritants and allergens. Active young children in schools can also catch skin infections such as viral warts, fungal skin and toenail infections as well as head lice. The safest, most cost-effective and time-saving treatment protocols we use ensures your child’s skin is restored to its healthy condition and maintained that way, keeping them Always Young.'
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Allergy tests can be performed to detect potential allergens to avoid. Blood tests can be performed to exclude medical causes that may lead to skin problems. ',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>An accurate diagnosis coupled with a skin regime to maintain skin health will ensure that you child’s skin remains healthy for longer.',
							escape: false,
						},
					]
				},
				'nails': {
					name: 'Nails',
					images: [
						'/images/conditions/nail.png',
						'/images/conditions/nail-color.jpg',
						'/images/conditions/melanoma.jpg',
					],
					content: [{
						el: 'p',
						content: 'Nails with abnormal colour or shape can be due to an underlying dermatological disorder or nail infection.',
					}, {
						el: 'p',
						content: '<b>What we can do to help you ?</b>',
						escape: false,
					}, {
						el: 'p',
						content: 'An accurate diagnosis through a thorough clinical history and clinical examination will be followed by a discussion with you on possible treatment options including creams or tablets, corrective nail surgery to solve your problem permanently or minimally invasive approach using laser when appropriate.',
					}, {
						el: 'p',
						content: 'Melanoma is a type of aggressive cancer affecting the skin under the nail. It may start as a black streak as shown in the photo and slowly progress to affect the finger and spread regionally. Early detection and local control with surgery and regional control after relevant regional scans will help improve outcome and survival in such cases.',
					}],
				},
				'mohs-micrographic-surgery': {
					name: 'MOHs Micrographic Surgery',
					images: [
						'/images/treatments/mohs.jpg'
					],
					content: [{
						el: 'h4',
						content: 'What is MOHS, how it works and why do it and where to get it done?',
					}, {
						el: 'p',
						content: 'MOHs micrographic surgery is a highly specialised form of skin cancer surgery where skin cancers are removed thoroughly and yet spares normal skin surrounding skin cancer tissue to minimise the size of scars. This is the gold standard of treatment in countries where skin cancer rates are high. In Malaysia, due to the lower rates of skin cancer and also through lack of case load, local experience with such surgeries are limited. It is important to have an experienced MOHs surgeon who have been well trained to ensure that skin cancer surgery is performed to the highest standards to give you the best cosmesis and skin cancer clearance rates.',
					}, {
						el: 'p',
						// content: 'Mohs micrographic surgery is superior to conventional surgery because the chance of complete removal of skin cancer using Mohs versus conventional surgery is estimated to be 99.9% and 90 % respectively.',
						content: 'The chance of complete removal of skin cancer using Mohs is estimated to be 99.9%.',
					}, {
						el: 'div',
						content: '<div style="max-width:400px;"><div className="embed-responsive embed-responsive-16by9"><iframe className="embed-responsive-item" src="https://drive.google.com/file/d/0B96OxkMggY7VTlkzenNGQnFEcVE/preview" width="640" height="480"></iframe></div></div>',
						escape: false,
					}],
				},
				'thread-vein': {
					name: 'Thread Vein Laser',
					images: [
						'/images/conditions/thread-vein1.jpg',
						'/images/conditions/thread-vein2.jpg',
						'/images/conditions/thread-vein3.jpg',
					],
					content: [{
						el: 'p',
						content: 'Thread veins are veins of varying sizes due to dilated blood vessels that tend to occur on the face and lower legs. Causes include underlying skin disorder such as rosacea, genetically inherited conditions that result in dilated blood vessels and high venous pressure due to pregnancy or obesity.',
					}, {
						el: 'p',
						content: 'Smaller veins can be easily and successfully treated using the latest Fotona long pulsed Nd Yag laser.<br/>Larger veins can be treated with injection sclerotherapy to shut these larger vessels down.',
						escape: false,
					}],
				},
			},
		},
		'aesthetics': {
			name: 'Aesthetics',
			child: {
				'pigmentation-problems': {
					name: 'Pigmentation Problems',
					description: 'Dark spots can appear on the surface of the skin or within the deeper layers of the skin.',
					images: [
						'/images/conditions/pigmentation_problems.jpg', '/images/conditions/pigmentation_1.jpg', '/images/conditions/pigmentation_2.jpg',
					], content: [
						{
							el: 'p',
							content: 'Dark spots can appear on the surface of the skin or within the deeper layers of the skin.<br><br>White spots may mean skin infection, an autoimmune condition or a certain rare form of skin cancer. ',
							escape: false,
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>A skin biopsy may be necessary if a skin cancer is suspected. Examination by an experienced specialist is crucial in order to avoid misdiagnosis. ',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br><i>Dark spots</i><br>The latest 2017 pico-in-nanosecond laser has arrived in Malaysia in AY Skin Specialist Clinic, offering you the latest technology that is both safe and effective for the treatment of dark spots.<br><br>Skin peels can lighten dark spots effectively especially when it is on the surface of the skin.<br><br><i>White spots</i><br>Depending on the cause of the white spots, creams can be used initially.<br><br>Phototherapy can be very useful to darken white spots at a faster rate.<br><br>Tablets can also be prescribed to help with either dark or white spots to even out skin tone.',
							escape: false,
						},
					]
				},
				'wrinkles-&-skin-folds': {
					name: 'Wrinkles & Skin Folds',
					images: [
						'/images/conditions/wrinkles.jpg'
					], content: [
						{
							el: 'p',
							content: '',
							escape: false,
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>',
							escape: false,
						}, {
							el: 'p',
							content: 'A skin analyzer can be used to quantify pigment and assess severity of wrinkles and skin fold. Close clinical examination with a Dermatoscope can also reveal depth of wrinkles and potential solutions.',
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>',
							escape: false,
						}, {
							el: 'p',
							content: 'Wrinkles and skin folds present at rest (when facial muscle is not moving also known as static lines), can be improved using AY Dermal Solutions range of overnight essence and cream. Prevention of further photodamage induced by UV rays can also be minimised through the regular application of AY Solar Defense. A good moisturiser that you are used to that suits your budget should be continued if your skin is dry. Fillers can be used to fill up static lines for immediate improvement.',
						}, {
							el: 'p',
							content: 'Wrinkles and skin folds on movement (when facial muscles are activated also known as active lines), can be improved through the use of silicone-based cosmetics to mask the appearance including pores. However, to achieve a natural bare-face confidence, Botulinum toxin injections into the correct muscle groups will relax the muscles causing wrinkles, hence softening the wrinkles overtime. Fotona 4D laser technology can be used to minimise pores, tighten the face and minimise wrinkles and pores to return you to your <i>Always Young</i> look.',
							escape: false,
						},
					]
				},
				'hair': {
					name: 'Hair',
					images: [
						'/images/conditions/hair.jpg'
					], content: [
						{
							el: 'p',
							// content: '<b>HAIR LOSS</b><br><br>Hair loss (alopecia) can be due to internal medical problems, medications, genetic factors and physical or psychological stress. Hair loss can be divided into scarring or non-scarring. Scarring hair loss needs urgent attention as delayed diagnosis and treatment leads to permanent hair loss. Non -scarring alopecia can be completely reversible especially when diagnosed early and treated appropriately. <br><br>Dr. Adrian Yong has received specialist training in the management of alopecia in Bologna, Italy as part of a European Academy of Dermatology and Venereology Specialist training module.',
							content: '<b>HAIR LOSS</b><br><br>Hair loss (alopecia) can be due to internal medical problems, medications, genetic factors and physical or psychological stress. Hair loss can be divided into scarring or non-scarring. Scarring hair loss needs urgent attention as delayed diagnosis and treatment leads to permanent hair loss. Non -scarring alopecia can be completely reversible especially when diagnosed early and treated appropriately.',
							escape: false,
						}, {
							el: 'p',
							content: 'The latest scientifically-based AY signature scalp treatment package that combines scalp treatment laser, hair nutrient solution and hair oral supplements can yield visible hair regrowth as early as 2 weeks and shows sustained results especially when other patient factors such as nutrition, lifestyle and scalp skin health is optimised. Hair laser is initially used to induce optimal blood flow in the scalp which then makes the hair follicles ready for the solution and supplements to work their magic. Even better improvement in hair regrowth stimulation can be achieved using platelet rich plasma injections to deliver growth factors into the scalp.',
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Scalp dermoscopy, alopecia hair pull test and blood tests may be performed to detect underlying medical problems.',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Depending on the diagnosis, anti-inflammatory creams, hair growth stimulants and tablets can be prescribed to slow down the rate of hair loss.<br><br>Injection of platelet rich plasma and hair mesotherapy to stimulate hair growth can also be performed to stimulate hair growth. Low-level light treatment maybe useful in improving a patient’s self-confidence although investigators in independent studies have not found a statistically significant improvement after treatment.<br><br>Hair transplant is a final option for severe hair loss that has stabilised for at least one year. This is to ensure that a good cosmetic outcome can be achieved following hair transplant.',
							escape: false,
						},
					]
				},
				'body': {
					name: 'Body',
					images: [
						'/images/conditions/body.jpg'
					], content: [
						{
							el: 'p',
							content: '<b>BODY CONTOURING</b><br><br>Body shapes can change following growth spurts, weight loss and childbirth in several areas including the buttocks, arms and abdomen. ',
							escape: false,
						}, {
							el: 'p',
							content: '<b>What we can do to help you ?</b>',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Tests</i><br>Blood tests can be performed to diagnose underlying medical and hormonal abnormalities and complications arising from obesity.',
							escape: false,
						}, {
							el: 'p',
							content: '<i>Treatments</i><br>Fat dissolving injection can be useful to reduce appearance of cellulite and fats.<br><br>Using the latest laser technology, a course of treatments can lead to improvement in  body contour and skin texture for patients with mild to moderate fat deposits.',
							escape: false,
						},
					]
				},
			},
		},
	},
	tests: {
		'patch-test': {
			name: 'Patch Test',
			images: [
				'/images/tests/patch_test.jpg'
			], content: [{
				el: 'p',
				content: 'Patch test is useful to detect presence of allergic contact dermatitis, that may cause worsening of eczema. Essential prior to escalating treatment for eczema to stronger medications.',
			}]
		},
		'blood-test': {
			name: 'Blood Test',
			images: [
				'/images/tests/bloodtest.jpg'
			], content: [{
				el: 'p',
				content: 'Comprehensive range of blood tests available at competitive prices to assist with diagnosis of numerous skin, hair and nail conditions.',
			}]
		},
		'autologous-serum-skin-testing': {
			name: 'Autologous serum skin testing',
			images: [
				'/images/tests/autologous.jpg'
			], content: [{
				el: 'p',
				content: 'Serum from your own blood is injected back just under your skin to assist with the diagnosis of autoimmunity in the context of treatment resistant chronic urticaria.',
			}]
		},
		// 'skin-analyzer': {
		// 	name: 'Skin Analyzer',
		// 	images: [
		// 		'/images/tests/skin_analyzer.png'
		// 	], content: [{
		// 		el: 'p',
		// 		content: 'Scanner mode measures pore, sebum, wrinkle and pigmentation extent. Sensor mode detects moisture, elasticity and skin tone.',
		// 	}]
		// },
		'histopathology': {
			name: 'Histopathology (Skin Biopsy Analysis)',
			images: [
				'/images/tests/histopathology.jpg'
			], content: [{
				el: 'p',
				content: 'Skin biopsy taken to diagnose a variety of skin conditions including inflammation, cancer, infection and pigmentary disturbance. This is performed under local anaesthetic to numb the biopsy area only and a skin specimen is then taken painlessly from the site, returning results in less than 5 working days.',
			}]
		},
		// 'doppler-ultrasound': {
		// 	name: 'Doppler Ultrasound',
		// 	images: [
		// 		'/images/tests/doppler.jpg'
		// 	], content: [{
		// 		el: 'p',
		// 		content: 'Doppler ultrasound is useful to diagnose the cause of swollen legs and leg ulcers. ',
		// 	}]
		// },
		'mole-dermatoscopy': {
			name: 'Mole Dermatoscopy',
			images: [
				'/images/tests/dermatoscopy.jpg',
			], content: [{
				el: 'p',
				// content: 'Dermatoscopy is a key component of higher specialist training in Dermatology in the United Kingdom. The handheld polarised light magnifier is used as an essential tool to differentiate between cancerous and non-cancerous skin lesions. The incidence of skin cancer in the UK is high, providing a wealth of experience, allowing you, the patient, to have access to accurate interpretation and diagnosis by a UK-trained Dermatologist. Harmless moles and pigmented spots can then be treated more conservatively, sparing you from a surgical procedure.',
				content: 'Dermatoscopy is a key component of higher specialist training in Dermatology in the United Kingdom. The handheld polarised light magnifier is used as an essential tool to differentiate between cancerous and non-cancerous skin lesions. The incidence of skin cancer in the UK is high, providing a wealth of experience, allowing you, the patient, to have access to accurate interpretation and diagnosis. Harmless moles and pigmented spots can then be treated more conservatively, sparing you from a surgical procedure.',
			}]
		},
	},
	treatments: {
		'botulinum-toxin-&-fillers': {
			name: 'Botulinum Toxin & Fillers',
			images: [
				'/images/treatments/Botulinum-Toxin-and-Fillers.jpg'
			], content: [{
				el: 'p',
				content: 'Someone could look older than their actual age when there are wrinkles from overactive muscles of facial expression or due to pressure such as sleep lines or decolletage. Static lines can also be due to fat falling under the influence of gravity as the overlying skin elastic tissue is lost allowing the fat to drag the overlying skin with it. Botulinum Toxin helps to relax muscles in areas where there is overactive muscles. ',
			}, {
				el: 'p',
				content: 'As we age, bone resorption progresses, leading to a sunken and shrunken look. Youth is associated with fuller, well-defined lips, cheeks and areas around the sides of your head. Also, an inverted triangle is the ideal youthful look that tends to reverse into an upright triangle as we age. Fillers placed skillfully in the right amounts in the right place can enhance your look, reversing many years of ageing and restoring youth.',
			}, {
				el: 'h4',
				content: 'Micro botulinum toxin - Effortless skin glow',
			}, {
				el: 'p',
				content: 'This latest evidence-based technique is the secret to glowing skin with less flushing, smaller pores and less fine lines.',
			}, {
				el: 'p',
				content: 'A complete anti-ageing approach should include skin conditioning treatments to achieve glowing skin to complete your new <i><b>A</b>lways <b>Y</b>oung</i> look.',
				escape: false,
			}]
		},
		'cryolipolysis': {
			name: 'Cryolipolysis (Fat Freezing)',
			images: [
				'/images/treatments/Cryolipolysis.jpg',
				'/images/treatments/Cryolipolysis-1.jpg',
			],
			content: [{
				el: 'p',
				content: 'Cryolipolysis is a non-invasive technique of freezing the fat cells to -9°C. The crystalized fat cells are gradually disposed of naturally by the body in the next few weeks.',
			}, {
				el: 'p',
				content: 'Shortest treatment time required as we can treat 4 body parts in 1 hour.',
			}, {
				el: 'p',
				content: 'Comprehensive assessment by specialist, in addition to reducing localised fats, overall health will be assessed and treated as well to prevent complications arising from being overweight.',
			}],
		},
		'cryotherapy-or-liquid-nitrogen': {
			name: 'Cryotherapy / Liquid Nitrogen',
			images: [
				'/images/treatments/cryotherapy-liquid-nitrogen.jpg'
			], content: [{
				el: 'p',
				content: 'Cryotherapy has stood the test of time in its efficacy in the treatment of superficial skin cancers, viral warts, corns, minor superficial skin growths that accumulates with ageing. This is a very economical and speedy way of treating superficial skin problems.',
			}]
		},
		'injection-sclerotherapy': {
			name: 'Injection Sclerotherapy',
			images: [
				'/images/treatments/injection-sclerotherapy.jpg'
			], content: [{
				el: 'p',
				content: 'Dilated veins starting from fine thread veins to thicker tortuous varicose veins can be due to damaged valves in the leg veins. Dilated veins may also occur due to increased pressures within the abdomen from being overweight, pregnancy or in occupations where prolonged standing is necessary. This results in the dilation of superficial leg veins resulting in unsightly worm-like protrusions in the lower legs. Besides looking unsightly, high pressures within leg veins can progress to form brownish stains of discolouration on the skin before progressing to leg ulcers that are difficult to heal. Ultrasound can be used to diagnose the underlying problem accurately before appropriate non-surgical treatments including lasers and injection sclerotherapy can be used to delay progression and complications resulting from the condition.',
			}]
		},
		'iontophoresis': {
			name: 'Iontophoresis',
			images: [
				'/images/treatments/iontophoresis.jpg'
			], content: [{
				el: 'p',
				content: 'Iontophoresis can be very useful for excessive sweating in palms and soles. Regular treatment at least twice a week for three weeks may prove useful, in which case patients can elect to buy their own home device.',
			}]
		},
		'laser': {
			name: 'Laser',
			images: [
				'/images/treatments/laser1.jpg',
				'/images/treatments/laser2.jpg'
			], content: [{
				el: 'p',
				content: '“Light amplification by stimulated emission of radiation” works on the skin by targeting specific cells to be damaged (e.g: pigment, blood vessels, hair), leaving surrounding structures undamaged. Successful laser treatment depends on the capability of the technology, specialist knowledge and constant improvements to protocols by laser practitioner. All three are a promise when you come to AY Skin Specialist for a tailor-made treatment.',
			}, {
				el: 'p',
				content: '<i>What can be achieved with laser at AY Skin Specialist Clinic ?</i>',
				escape: false,
			}, {
				el: 'ol',
				content: [{
					el: 'li',
					content: 'Tattoo Removal (Black pigment)',
				}, {
					el: 'li',
					content: 'Freckles, Age spots',
				}, {
					el: 'li',
					content: 'Cafe au lait',
				}, {
					el: 'li',
					content: 'Naevus of Ota',
				}, {
					el: 'li',
					content: 'Melasma',
				}, {
					el: 'li',
					content: 'Skin rejuvenation, tightening and texture improvement',
				}, {
					el: 'li',
					content: 'Hair removal',
				}, {
					el: 'li',
					content: 'Acne and acne scar revision',
				}, {
					el: 'li',
					content: 'Thread veins and enlarged blood vessels ',
				}, {
					el: 'li',
					content: 'Nail fungal infection treatment',
				}, {
					el: 'li',
					content: 'Viral wart',
				}, {
					el: 'li',
					content: 'Skin tag removal',
				}, {
					el: 'li',
					content: 'Wrinkle reduction',
				}, {
					el: 'li',
					content: 'Snoring treatment',
				}, {
					el: 'li',
					content: 'Body skin tightening and contouring',
				}, {
					el: 'li',
					content: '4D Face Tightening',
				}],
			}
			]
		},
		'medical-grade-skin-peels': {
			name: 'Medical-grade Skin Peels',
			images: [
				// '/images/treatments/skin-peels.jpg'
				'/images/treatments/chemical-peel.jpg'
			], content: [{
				el: 'p',
				content: 'Skin peels using safe and effective fruit acids in varying concentrations expertly to achieve silky smooth texture, tone and colour. Acne, fine wrinkles, superficial pigmentation and age spots can be treated effectively this way.',
			}]
		},
		'mesotherapy': {
			name: 'Mesotherapy',
			images: [
				'/images/treatments/mesotherapy.jpg'
			], content: [{
				el: 'p',
				content: 'Hair regrowth, facial rejuvenation, cellulite and fat reduction can all be achieved through carefully selected mesotherapy ingredients.',
			}]
		},
		'minor-skin-surgery&skin-cancer-removal': {
			name: 'Minor Skin Surgery & Skin Cancer Removal',
			images: [
				'/images/treatments/minor-skin-surgery.jpg'
			], content: [{
				el: 'p',
				content: 'Dermatological surgery involves the use of local anaesthetic to numb a local area before removal of lumps and bumps just under and in the skin. An ultrasound can be used beforehand to confirm nature of a growth before skin surgery is performed for greater accuracy.',
			}]
		},
		'mohs-micrographic-surgery': {
			name: 'MOHs Micrographic Surgery',
			images: [
				'/images/treatments/mohs.jpg'
			],
			content: [{
				el: 'h4',
				content: 'What is MOHS, how it works and why do it and where to get it done?',
			}, {
				el: 'p',
				content: 'MOHs micrographic surgery is a highly specialised form of skin cancer surgery where skin cancers are removed thoroughly and yet spares normal skin surrounding skin cancer tissue to minimise the size of scars. This is the gold standard of treatment in countries where skin cancer rates are high. In Malaysia, due to the lower rates of skin cancer and also through lack of case load, local experience with such surgeries are limited. It is important to have an experienced MOHs surgeon who have been well trained to ensure that skin cancer surgery is performed to the highest standards to give you the best cosmesis and skin cancer clearance rates.',
			}, {
				el: 'p',
				// content: 'Mohs micrographic surgery is superior to conventional surgery because the chance of complete removal of skin cancer using Mohs versus conventional surgery is estimated to be 99.9% and 90 % respectively.',
				content: 'The chance of complete removal of skin cancer using Mohs is estimated to be 99.9%.',
			}, {
				el: 'div',
				content: '<div style="max-width:400px;"><div className="embed-responsive embed-responsive-16by9"><iframe className="embed-responsive-item" src="https://drive.google.com/file/d/0B96OxkMggY7VTlkzenNGQnFEcVE/preview" width="640" height="480"></iframe></div></div>',
				escape: false,
			}],
		},
		// 'mohs-micrographic-surgery': {
		// 	name: 'Mohs Micrographic Surgery',
		// 	images: [
		// 		'/images/treatments/mohs.jpg'
		// 	], content: [{
		// 		el: 'p',
		// 		// content: 'Associate Professor Adrian Yong pioneered Mohs surgery in Malaysia in 2015. Having completed his dermatological surgery training in the UK and USA, he has brought this gold standard treatment for skin cancers to Malaysia. To understand more, please click on the following hyperlink to view video about this form of treatment. <a href="http://www.dermatology.org.my/patient_information_videos.php" target="_blank">http://www.dermatology.org.my/patient_information_videos.php</a>',
		// 		content: 'This is the gold standard treatment for skin cancers in Malaysia.',
		// 		escape: false,
		// 	}, {
		// 		el: 'div',
		// 		content: '<div style="max-width:400px;"><div className="embed-responsive embed-responsive-16by9"><iframe className="embed-responsive-item" src="https://drive.google.com/file/d/0B96OxkMggY7VTlkzenNGQnFEcVE/preview" width="640" height="480"></iframe></div></div>',
		// 		escape: false,
		// 	}]
		// },
		'phototherapy': {
			name: 'Phototherapy',
			images: [
				'/images/treatments/phototherapy.PNG'
			], content: [{
				el: 'p',
				content: 'The latest narrow band UVB lamps that have high energy outputs delivered safely and effectively with very short treatment times is available at AY Skin Specialist Clinic. This enables us to treat conditions including eczema, psoriasis, vitiligo and certain forms of skin cancer.',
			}]
		},
		'platelet-rich-plasma': {
			name: 'Platelet Rich Plasma',
			images: [
				'/images/treatments/platelet_rich_plasma.PNG'
			], content: [{
				el: 'p',
				content: 'PRP has been reported to help rejuvenate the skin, stimulate hair growth and assist in wound healing in certain circumstances. Associate Professor Adrian Yong acts as a bridge between medical dermatology and cosmetic dermatology in being able to use this treatment for both aesthetic and medical indications.',
			}]
		},
		'nail-surgery': {
			name: 'Nail Surgery',
			images: [
				'/images/treatments/nail-surgery.png'
			], content: [{
				el: 'p',
				content: 'Nail surgery is a specialised area effective for the treatment of conditions such as pincer nail, ingrowing toenails, pigmented streak along nails and also for suspected cancers affecting the nail and nailbed.',
			}]
		},
		// 'radio-frequency-skin-tightening': {
		// 	name: 'Radio Frequency Skin Tightening',
		// 	images: [
		// 		'/images/treatments/face_lifting.PNG'
		// 	], content: [{
		// 		el: 'p',
		// 		content: 'Radiofrequency can be used for body shaping and fat reduction by creating localised heating causing fat to melt. Wrinkle reduction and skin tightening around the face can also compensate for volume loss and hence delaying sagging of face by stimulating collagen production.',
		// 	}]
		// },
		'korean-hydrafacial': {
			name: 'Korean Hydrafacial',
			images: [
				'/images/treatments/korean_face_infusion.PNG'
			],
			content: [{
				el: 'p',
				content: 'The Korean Hydrafacial device is the latest technology in non-laser skin resurfacing. This face infusion device combines cleansing, exfoliation, extraction, hydration and antioxidant protection simultaneously, resulting in clearer, more beautiful skin with no discomfort or downtime. The treatment is soothing, moisturizing, non-invasive and non-irritating. The latter is unlike the uncomfortable conventional dermabrasion such as Diamond peel and Power Crystal peel and therefore can be used even during an acne flare',
			}]
		},
		'korean-threadlift': {
			// name: 'Face Non-Surgical Threadlift',
			name: 'Korean Threadlift',
			images: [
				'/images/treatments/threadlift.jpg'
			],
			content: [{
				el: 'p',
				// content: 'Korean threadlift has revolutionised facelifting. Traditionally, a facelift could only be achieved through open surgical techniques. Threadlift now enables us to use very fine needle insertion points only leaving no scars and minimal downtime. Effects after threadlifting typically lasts from 6 to 9 months. Effects include a V-shaped more youthful looking face. It can also be used to lift the eyebrow, cheeks, corner of the mouth, nasolabial fold and neck. This procedure is natural extension to dermatological surgery whereby threads are normally used to close wounds after surgery but this time, the threads are placed through tiny entry points, avoiding the need to make any cuts in the skin. The areas where threads are passed is numbed with local anaesthesia before the procedure is performed an a typical threadlift procedure can be done over lunch break for a busy executive.',
				content: 'Korean threadlift has revolutionised facelifting. Traditionally, a facelift could only be achieved through open surgical techniques. Threadlift now enables us to use very fine needle insertion points only leaving no scars and minimal downtime. Effects after threadlifting typically lasts from one and a half to two years. Effects include a V-shaped more youthful looking face. It can also be used to lift the eyebrow, cheeks, corner of the mouth, nasolabial fold and neck. This procedure is natural extension to dermatological surgery whereby threads are normally used to close wounds after surgery but this time, the threads are placed through tiny entry points, avoiding the need to make any cuts in the skin. The areas where threads are passed is numbed with local anaesthesia before the procedure is performed an a typical threadlift procedure can be done over lunch break for a busy executive.',
			}],
		},
		'high-intensity-focused-ultrasound': {
			name: 'High Intensity Focused Ultrasound (HIFU)',
			images: [
				'/images/treatments/high-intensity-focused-ultrasound.jpg',
			],
			content: [{
				el: 'p',
				content: 'High-intensity focused ultrasound (HIFU) is a non-invasive therapy that uses focused ultrasound waves to thermally ablate the fat tissue without downtime to achieve a slimmer face. In addition the thermal stimulation is effective in tightening the more superficial dermis to stimulate new collagen formation. On the face, HIFU can also be used to target the SMAs layer such that it produces a non-surgical facelift effect.',
			}, {
				el: 'p',
				content: 'HIFU can also be used for skin tightening and lifting for skin tightening and lifting for eyes, face, neck, abdomen, arm loose saggy skin, and body contouring.',
			}],
		},
	},
	newsMedia: [{
		label: 'Associate Professor Dr. Adrian Yong Consultant Dermatologist of AY Skin Specialist Clinic at APDLS',
		images: [{
			src: '/images/news-media/asia-pacific-dermatitis-leaders-summit-jan2018/apdls.jpg',
		}],
	}, {
		label: 'Associate Professor Dr Adrian Yong, previous Head of Dermatology in University Malaya co-authors British Journal of Dermatology Guidelines on management of itching for UK dermatologists.',
		images: [{
			src: '/images/news-media/british-association-of-dermatologists-guidelines-2018/BJD-pruritus-guidelines.jpg',
		}],
	}, {
		label: 'Associate Professor Dr. Adrian Yong Consultant Dermatologist and Dermatological surgeon shares his experience and knowledge over BFM radio interview on skin allergy.',
		images: [{
			src: '/images/news-media/bfm-interview-2018/BFM-interview.jpg',
		}],
	}, {
		label: 'Associate Professor Dr. Adrian Yong Consultant Dermatologist of AY Skin Specialist Clinic answers live questions on Melody FM on skin allergy.',
		images: [{
			src: '/images/news-media/melodyfm-interview-2018/MelodyFMAYSS.jpg',
		}],
	}, {
		label: 'Associate Professor Dr. Adrian Yong Consultant Dermatologist & Dermatological Surgeon shares with Watsons pharmacist and public about skin allergy and advises on selection of skin care.',
		images: [{
			src: '/images/news-media/watsons-skincare-advice/WatsonsAYSS.jpg',
		}],
	}, {
		label: 'Malaysian Journal of Dermatology 2017',
		content: [{
			el: 'p',
			content: '<a href="/images/news-media/malaysian-journal-of-dermatology-2017/Booklet_A4_Malaysian_Journal_of_Dermatology_2017.pdf" target="_blank">View Journal (pdf)</a>',
			escape: false,
		}],
		images: [{
			src: '/images/news-media/malaysian-journal-of-dermatology-2017/1.jpg',
			caption: null,
		}],
	// }, {
	// 	label: 'Featured in The Sun Daily, "Precision formula care for skin"',
	// 	content: [{
	// 		el: 'p',
	// 		content: '<a href="/images/news-media/thesun-write-up-eucerin/16082017.pdf" target="_blank">Read the article (pdf)</a>',
	// 		escape: false,
	// 	}],
	// 	images: [{
	// 		src: '/images/news-media/thesun-write-up-eucerin/1.jpg',
	// 		caption: null,
	// 	}],
	}, {
		label: 'Health Workshop - World Allergy Day Public Forum',
		images: [{
			src: '/images/news-media/health-workshop-world-allergy-day/1.jpg',
			caption: null,
		}, {
			src: '/images/news-media/health-workshop-world-allergy-day/2.jpg',
			caption: null,
		}, {
			src: '/images/news-media/health-workshop-world-allergy-day/3.jpg',
			caption: null,
		}, {
			src: '/images/news-media/health-workshop-world-allergy-day/4.jpg',
			caption: null,
		}],
	}, {
		label: 'Malaysian Urticaria Expert Group',
		images: [{
			src: '/images/news-media/malaysian-urticaria-expert-group/1.jpg',
			caption: null,
		}],
	}, {
		label: 'Updates on allergy management for doctors',
		images: [{
			src: '/images/news-media/updates-on-allergy-management/1.jpg',
			caption: null,
		}, {
			src: '/images/news-media/updates-on-allergy-management/2.jpg',
			caption: null,
		}],
	}, {
		label: 'Skin Cancer & Surgery',
		images: [{
			src: '/images/news-media/skin-cancer-surgery-mohs/1.jpg',
			caption: 'Mohs Micrographic Surgery',
		}, {
			src: '/images/news-media/skin-cancer-surgery-mohs/2.gif',
			caption: 'Mohs Micrographic Surgery',
		}, {
			src: '/images/news-media/skin-cancer-surgery-mohs/3.jpg',
			caption: null,
		}],
	}],
}



// WEBPACK FOOTER //
// ./src/data.js